<script>
  import { Link, store, imgSrc } from '$client';
  export let data;
  const { city } = store;
</script>

<section class="container logo-pattern" id="services">
  <slot />
  <h2 class="margin-block h2">{data.header}</h2>
  <ul class="margin-bottom">
    {#each data.data.data as service}
      <li>
        <article class="service">
          <h3>{service.attributes.ancor} в г.{$city.header}</h3>
          <img
            loading="lazy"
            height={service.attributes.cardImg.data.attributes.height}
            width={service.attributes.cardImg.data.attributes.width}
            src={imgSrc(service.attributes.cardImg.data.attributes.url)}
            alt={service.attributes.cardImg.data.attributes.alternativeText} />
          <Link attributes={{ class: 'push-button' }} href="/usluga-{service.attributes.url}">Заказать вывоз</Link>
        </article>
      </li>
    {/each}
  </ul>
  <Link href="/ceny">Показать ещё</Link>
</section>

<style lang="scss">
  #services {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 40px;

    :global(> a) {
      gap: 10px;
      margin-left: 50%;
      padding: 18px 40px;
      color: var(--primary-dark, #2c333c);
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 22.4px */
      white-space: nowrap;
      text-align: center;
      border: 2px solid rgb(44 51 60 / 75%);
      border-radius: 5px;
      transform: translateX(-50%);
      transition: all 0.1s;

      &:hover {
        background-color: #22eaac;
        border-color: #22eaac;
      }
    }
  }

  h2 {
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
    letter-spacing: 0.36px;
  }

  ul {
    display: inline-grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 40px;
    width: 100%;

    li {
      display: contents;
    }

    @media only screen and (max-width: 1199.98px) {
      grid-template-columns: 1fr 1fr;
    }

    @media only screen and (max-width: 767.98px) {
      grid-template-columns: 1fr;
    }
  }

  .service {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    min-height: 220px;
    padding-right: 39%;
    padding-left: 15px;
    overflow: hidden;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 1px 15px 0 rgb(0 15 92 / 5%);
    padding-block: 24px;

    :global(a),
    :global(div) {
      gap: 10px;
      padding: 16px 24px;
      color: #fff;
      font-weight: 600;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 22.4px */
      background: #2c333c;
      border-radius: 5px;

      @media screen and (max-width: 575.98px) {
        font-size: 14px;
      }
    }

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      display: block;
      width: 40%;
      height: 100%;
      background-color: #22eaac;
      background-image: url('https://admin.uberi.pro/uploads/Pattern_1_3574a6acc6.svg');
      background-repeat: repeat;
      background-position: center center;
      background-size: 420%;
      content: '';
      clip-path: polygon(0 0, 100% 0, 100% 100%, 41% 100%);
    }

    h3 {
      color: #2c333c;
      font-weight: bold;
      font-size: 20px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 28px */

      @media screen and (max-width: 575.98px) {
        font-size: 16px;
      }
    }

    img {
      position: absolute;
      bottom: -5%;
      z-index: 2;
      width: auto;
      height: 100%;
      margin-left: 50%;
    }
  }
</style>
